import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { Tag, Tooltip } from "antd";
import { statuses } from "../data";
import s from "./styles.module.scss";

export const getStatus = (t: (key: string) => string) => {
  return [
    { value: "new", label: t("Новый") },
    { value: "incomplete", label: t("Требуется доработка") },
    { value: "corrected", label: t("Скорректированно") },
    { value: "paid", label: t("Оплачен") },
    { value: "ready_to_payment", label: t("Готов к оплате") },
    { value: "paid_through_bank", label: t("Оплачен через банк") },
    { value: "paid_by_card", label: t("Оплачен банковской картой") },
    { value: "payment_confirmed", label: t("Оплата подтверждена") },
    { value: "completed", label: t("Завершенный") },
    { value: "rejected", label: t("Отрицательный") },
  ];
};

export const getStatusTag = (
  status: string,
  size: string,
  t: (key: string) => string,
) => {
  const status_label = statuses?.find((it) => it?.value === status)?.label;
  switch (status) {
    case "new":
      return (
        <Tag
          color="processing"
          className={size === "sm" ? s.tagSm : size === "md" ? s.tagMd : s.tag}
        >
          <CheckCircleOutlined style={{ marginRight: "5px" }} />
          {status_label && t(status_label)}
        </Tag>
      );
    case "accepted":
      return (
        <Tag
          color="processing"
          className={size === "sm" ? s.tagSm : size === "md" ? s.tagMd : s.tag}
        >
          <CheckCircleOutlined style={{ marginRight: "5px" }} />
          {status_label && t(status_label)}
        </Tag>
      );
    case "incomplete":
      return (
        <Tag color="orange" className={size === "sm" ? s.tagSm : s.tag}>
          <ExclamationCircleOutlined style={{ marginRight: "5px" }} />
          {status_label && t(status_label)}
        </Tag>
      );
    case "corrected":
      return (
        <Tag
          color="cyan"
          className={size === "sm" ? s.tagSm : size === "md" ? s.tagMd : s.tag}
        >
          <CheckCircleOutlined style={{ marginRight: "5px" }} />
          {status_label && t(status_label)}
        </Tag>
      );
    case "ready_to_payment":
      return (
        <Tag color="success" className={size === "sm" ? s.tagSm : s.tag}>
          <CheckCircleOutlined style={{ marginRight: "5px" }} />
          {status_label && t(status_label)}
        </Tag>
      );
    case "payment_confirmed":
      return (
        <Tag color="green" className={size === "sm" ? s.tagSm : s.tag}>
          <CheckCircleOutlined style={{ marginRight: "5px" }} />
          {status_label && t(status_label)}
        </Tag>
      );
    case "paid_through_bank":
      return (
        <Tag color="green" className={size === "sm" ? s.tagSm : s.tag}>
          <CheckCircleOutlined style={{ marginRight: "5px" }} />
          {status_label && t(status_label)}
        </Tag>
      );
    case "paid":
      return (
        <Tag color="green" className={size === "sm" ? s.tagSm : s.tag}>
          <CheckCircleOutlined style={{ marginRight: "5px" }} />
          {status_label && t(status_label)}
        </Tag>
      );
    case "paid_by_card":
      return (
        <Tag color="green" className={size === "sm" ? s.tagSm : s.tag}>
          <CheckCircleOutlined style={{ marginRight: "5px" }} />
          {status_label && t(status_label)}
        </Tag>
      );
    case "completed":
      return (
        <Tag color="default" className={size === "sm" ? s.tagSm : s.tag}>
          <CheckCircleOutlined style={{ marginRight: "5px" }} />
          {status_label && t(status_label)}
        </Tag>
      );
    case "rejected":
      return (
        <Tag color="error" className={size === "sm" ? s.tagSm : s.tag}>
          <CloseCircleOutlined style={{ marginRight: "5px" }} />
          {status_label && t(status_label)}
        </Tag>
      );
  }
};

export const getListStatusTag = (
  status: string,
  size: string,
  t: (key: string) => string,
) => {
  const statusLabel =
    getStatus(t).find((it) => it.value === status)?.label ?? "";

  const className =
    size === "sm" ? s.listTagSm : size === "md" ? s.listTagMd : s.listTag;

  switch (status) {
    case "new":
      return (
        <Tag color="processing" className={className}>
          <ExclamationCircleOutlined style={{ marginRight: 3 }} />
          {statusLabel}
        </Tag>
      );

    case "incomplete":
      return (
        <Tag color="orange" className={className}>
          <ExclamationCircleOutlined style={{ marginRight: 3 }} />
          {statusLabel}
        </Tag>
      );

    case "corrected":
    case "ready_to_payment":
    case "payment_confirmed":
    case "paid":
    case "paid_by_card":
    case "paid_through_bank":
      return (
        <Tag
          color={
            status === "corrected"
              ? "cyan"
              : status === "ready_to_payment"
                ? "success"
                : "green"
          }
          className={className}
        >
          <CheckCircleOutlined style={{ marginRight: 3 }} />
          {statusLabel}
        </Tag>
      );

    case "completed":
      return (
        <Tag
          className={className}
          style={{
            backgroundColor: "#f0f0f0",
            color: "gray",
          }}
        >
          <CheckCircleOutlined style={{ marginRight: 3 }} />
          {statusLabel}
        </Tag>
      );

    case "rejected":
      return (
        <Tag color="error" className={className}>
          <CloseCircleOutlined style={{ marginRight: 3 }} />
          {statusLabel}
        </Tag>
      );

    default:
      return null;
  }
};

export const getCountryStatusTag = (
  country: string,
  status: string,
  size: string,
  t: (key: string) => string,
) => {
  const status_label = statuses?.find((it) => it?.value === status)?.label;
  switch (status) {
    case "new":
      return (
        <Tooltip title={t("Новый")} color="gray" style={{ fontSize: "12px" }}>
          <Tag
            color="processing"
            className={
              size === "sm"
                ? s.listTagSm
                : size === "md"
                  ? s.listTagMd
                  : s.listTag
            }
          >
            {/* <CheckCircleOutlined style={{ marginRight: "5px" }} /> */}
            {status_label && t(country)}
          </Tag>
        </Tooltip>
      );
    case "incomplete":
      return (
        <Tag
          color="orange"
          className={
            size === "sm"
              ? s.listTagSm
              : size === "md"
                ? s.listTagMd
                : s.listTag
          }
        >
          {/* <ExclamationCircleOutlined style={{ marginRight: "5px" }} /> */}
          {status_label && t(country)}
        </Tag>
      );
    case "corrected":
      return (
        <Tag
          color="cyan"
          className={
            size === "sm"
              ? s.listTagSm
              : size === "md"
                ? s.listTagMd
                : s.listTag
          }
        >
          {/* <CheckCircleOutlined style={{ marginRight: "5px" }} /> */}
          {status_label && t(country)}
        </Tag>
      );
    case "ready_to_payment":
      return (
        <Tag
          color="success"
          className={
            size === "sm"
              ? s.listTagSm
              : size === "md"
                ? s.listTagMd
                : s.listTag
          }
        >
          {/* <CheckCircleOutlined style={{ marginRight: "5px" }} /> */}
          {status_label && t(country)}
        </Tag>
      );
    case "payment_confirmed":
      return (
        <Tag
          color="green"
          className={
            size === "sm"
              ? s.listTagSm
              : size === "md"
                ? s.listTagMd
                : s.listTag
          }
        >
          {/* <CheckCircleOutlined style={{ marginRight: "5px" }} /> */}
          {status_label && t(country)}
        </Tag>
      );
    case "paid_through_bank":
      return (
        <Tag
          color="green"
          className={
            size === "sm"
              ? s.listTagSm
              : size === "md"
                ? s.listTagMd
                : s.listTag
          }
        >
          {/* <CheckCircleOutlined style={{ marginRight: "5px" }} /> */}
          {status_label && t(country)}
        </Tag>
      );
    case "paid_by_card":
      return (
        <Tag
          color="green"
          className={
            size === "sm"
              ? s.listTagSm
              : size === "md"
                ? s.listTagMd
                : s.listTag
          }
        >
          {/* <CheckCircleOutlined style={{ marginRight: "5px" }} /> */}
          {status_label && t(country)}
        </Tag>
      );
    case "completed":
      return (
        <Tag
          color="default"
          className={
            size === "sm"
              ? s.listTagSm
              : size === "md"
                ? s.listTagMd
                : s.listTag
          }
        >
          {/* <CheckCircleOutlined style={{ marginRight: "5px" }} /> */}
          {status_label && t(country)}
        </Tag>
      );
    case "rejected":
      return (
        <Tag
          color="error"
          className={
            size === "sm"
              ? s.listTagSm
              : size === "md"
                ? s.listTagMd
                : s.listTag
          }
        >
          {/* <CloseCircleOutlined style={{ marginRight: "5px" }} /> */}
          {status_label && t(country)}
        </Tag>
      );
  }
};
